import { Link } from 'gatsby';
import type React from 'react';
import { useEffect, useState } from 'react';

import { useLanguage } from '../../context/LanguageContext';
import styles from './CookieBanner.module.css';

const STORAGE_KEY = 'minihold-cookie-notice-dismissed';

const privacyRoutes = {
  de: '/datenschutz/',
  en: '/en/data-protection-information/',
};

/**
 * Informational banner stating that the site uses no cookies or trackers
 * (see content/{de,en}/pages/datenschutz.md §5). Dismiss-only, not a
 * consent gate — there's nothing to opt in or out of.
 */
const CookieBanner: React.FC<{ lang: 'de' | 'en' }> = ({ lang }) => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!window.localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  if (!visible) {
    return null;
  }

  const dismiss = () => {
    window.localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  return (
    <div className={styles.banner} role="status">
      <div className={styles.container}>
        <p className={styles.text}>
          {t('cookieBanner.message')}{' '}
          <Link to={privacyRoutes[lang]} className={styles.link}>
            {t('cookieBanner.linkText')}
          </Link>
          .
        </p>
        <button type="button" className={styles.dismiss} onClick={dismiss}>
          {t('cookieBanner.dismiss')}
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;
